module.exports = __webpack_public_path__ + "img/15.ed0ef1b8.jpg";